import { render } from "./Operate.vue?vue&type=template&id=188ad981&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"

import "./Operate.vue?vue&type=style&index=0&id=188ad981&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188ad981"]])

export default __exports__